import { Source } from 'src/types';

export const createCites = (source: Source): string => {
	if (!source.position || !source.url) {
		return '';
	}
	const marker = source.outdated ? '#cite-outdated' : '#cite-normal';

	return `[${source.position}](${source.url}${marker})`;
};
